/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SocialLoginRequest
 */
export interface SocialLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequest
     */
    provider: SocialLoginRequestProviderEnum;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequest
     */
    authorizationCode: string;
    /**
     * 
     * @type {string}
     * @memberof SocialLoginRequest
     */
    redirectUri: string;
}


/**
 * @export
 */
export const SocialLoginRequestProviderEnum = {
    Google: 'GOOGLE'
} as const;
export type SocialLoginRequestProviderEnum = typeof SocialLoginRequestProviderEnum[keyof typeof SocialLoginRequestProviderEnum];


/**
 * Check if a given object implements the SocialLoginRequest interface.
 */
export function instanceOfSocialLoginRequest(value: object): value is SocialLoginRequest {
    if (!('provider' in value) || value['provider'] === undefined) return false;
    if (!('authorizationCode' in value) || value['authorizationCode'] === undefined) return false;
    if (!('redirectUri' in value) || value['redirectUri'] === undefined) return false;
    return true;
}

export function SocialLoginRequestFromJSON(json: any): SocialLoginRequest {
    return SocialLoginRequestFromJSONTyped(json, false);
}

export function SocialLoginRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SocialLoginRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'provider': json['provider'],
        'authorizationCode': json['authorizationCode'],
        'redirectUri': json['redirectUri'],
    };
}

export function SocialLoginRequestToJSON(value?: SocialLoginRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'provider': value['provider'],
        'authorizationCode': value['authorizationCode'],
        'redirectUri': value['redirectUri'],
    };
}

